import { Capacitor, PluginListenerHandle } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

/** Test seam — Capacitor plugin objects are not reliably spy-able. */
export const capacitorBrowserEvents = {
  onFinished: (listener: () => void): Promise<PluginListenerHandle> => Browser.addListener('browserFinished', listener),
  close: (): Promise<void> => Browser.close(),
};

/**
 * MainActivity usa taskAffinity="" (BQM-3595), así que BrowserControllerActivity queda en otra tarea
 * y no se cierra al volver del Custom Tab. La siguiente Browser.open() reutiliza esa instancia y no abre nada.
 */
export function startAndroidBrowserCleanup(): () => void {
  if (Capacitor.getPlatform() !== 'android') {
    return () => undefined;
  }

  const handle = capacitorBrowserEvents.onFinished(() => {
    capacitorBrowserEvents.close().catch(() => undefined);
  });

  return () => {
    void handle.then((h) => h.remove());
  };
}
